var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftPanel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 28,
    viewBox: "0 0 12 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.05 26.8501C10.85 27.2501 10.35 27.4001 9.95002 27.1501C0.500017 21.3001 0.600017 7.10007 10.2 1.40007C10.45 1.25007 10.8 1.35007 10.95 1.60007C11.1 1.85007 11 2.15007 10.75 2.30007C1.80002 7.65007 1.90002 20.4501 10.75 25.8501C11.1 26.0501 11.2 26.5001 11.05 26.8501Z",
    fill: "url(#paint0_linear_1362_338)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7 4.70012C10 5.25012 9.25 5.55012 8.5 5.70012C7.75 5.85012 7.05 5.75012 6.5 5.35012C7.75 3.70012 9.9 3.55012 10.7 4.70012Z",
    fill: "url(#paint1_linear_1362_338)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.65015 0.700195C6.65015 1.5002 6.00015 2.5002 5.85015 3.3502C5.65015 4.2502 5.90015 4.9502 6.45015 5.4002C7.65015 3.8002 8.45015 1.8502 7.65015 0.700195Z",
    fill: "url(#paint2_linear_1362_338)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.30005 7.10039C7.80005 7.75039 7.20005 8.30038 6.55005 8.60039C5.90005 8.90039 5.15005 9.05038 4.55005 8.80038C5.25005 6.85038 7.20005 6.25039 8.30005 7.10039Z",
    fill: "url(#paint3_linear_1362_338)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.25005 4.1001C3.55005 5.0501 3.25005 6.1501 3.35005 7.0001C3.45005 7.8501 3.85005 8.5001 4.50005 8.7501C5.20005 7.0001 5.35005 5.0001 4.25005 4.1001Z",
    fill: "url(#paint4_linear_1362_338)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.75005 9.95027C6.45005 10.7003 6.00005 11.3503 5.45005 11.8003C4.90005 12.2503 4.25005 12.6003 3.55005 12.5003C3.80005 10.5003 5.45005 9.40027 6.75005 9.95027Z",
    fill: "url(#paint5_linear_1362_338)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M2.05017 8.15039C1.65017 9.25039 1.65017 10.3504 1.95017 11.1504C2.25017 11.9504 2.85017 12.4504 3.55017 12.5004C3.75017 10.6004 3.35017 8.70039 2.05017 8.15039Z",
    fill: "url(#paint6_linear_1362_338)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.0001 13.0501C5.9001 13.8501 5.6501 14.6001 5.2501 15.2001C4.8501 15.8001 4.3001 16.2501 3.6001 16.3501C3.3001 14.3501 4.6501 12.8501 6.0001 13.0501Z",
    fill: "url(#paint7_linear_1362_338)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00012 12.5503C0.900117 13.7003 1.20012 14.7503 1.70012 15.4503C2.20012 16.1503 2.90012 16.4503 3.60012 16.3503C3.30012 14.4503 2.40012 12.7503 1.00012 12.5503Z",
    fill: "url(#paint8_linear_1362_338)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.10009 16.25C6.25009 17.05 6.15009 17.85 5.95009 18.5C5.70009 19.2 5.30009 19.8 4.65009 20.1C3.85009 18.2 4.75009 16.4 6.10009 16.25Z",
    fill: "url(#paint9_linear_1362_338)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M1.2002 17.0501C1.4002 18.2001 1.9502 19.1501 2.6502 19.6501C3.3502 20.2001 4.1002 20.3001 4.7002 20.0501C3.9002 18.3001 2.5502 16.9001 1.2002 17.0501Z",
    fill: "url(#paint10_linear_1362_338)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M7.05004 19.3003C7.40004 20.0503 7.55004 20.8003 7.50004 21.5503C7.45004 22.3003 7.25004 23.0003 6.70004 23.4503C5.40004 21.8003 5.80004 19.8003 7.05004 19.3003Z",
    fill: "url(#paint11_linear_1362_338)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 21.4003C3 22.4503 3.8 23.2503 4.6 23.6003C5.4 23.9503 6.2 23.9003 6.7 23.4503C5.45 21.9003 3.8 20.9003 2.5 21.4003Z",
    fill: "url(#paint12_linear_1362_338)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8501 22C9.4001 22.65 9.8001 23.35 10.0001 24.1C10.2001 24.85 10.2001 25.6 9.8501 26.15C7.9501 24.95 7.7501 22.85 8.8501 22Z",
    fill: "url(#paint13_linear_1362_338)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M5.05005 25.3003C5.85005 26.2003 6.90005 26.7503 7.80005 26.9003C8.70005 27.0503 9.45005 26.7503 9.85005 26.2003C8.05005 25.0003 6.15005 24.4503 5.05005 25.3003Z",
    fill: "url(#paint14_linear_1362_338)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1362_338",
    x1: 12.4166,
    y1: -4.88734,
    x2: -0.0257464,
    y2: -4.07967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1362_338",
    x1: 11.3665,
    y1: 3.51921,
    x2: 6.14291,
    y2: 6.00874,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1362_338",
    x1: 8.31976,
    y1: -0.426117,
    x2: 5.00715,
    y2: -0.108552,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1362_338",
    x1: 8.89511,
    y1: 6.19632,
    x2: 3.79715,
    y2: 7.98175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1362_338",
    x1: 5.32339,
    y1: 2.98577,
    x2: 2.71452,
    y2: 3.18418,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1362_338",
    x1: 7.25783,
    y1: 9.16005,
    x2: 2.64637,
    y2: 10.2808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1362_338",
    x1: 3.89442,
    y1: 7.10795,
    x2: 1.07369,
    y2: 7.35638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1362_338",
    x1: 6.38764,
    y1: 12.2371,
    x2: 2.74382,
    y2: 12.7888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1362_338",
    x1: 4.01573,
    y1: 11.6352,
    x2: 0.0963722,
    y2: 12.1881,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1362_338",
    x1: 6.46166,
    y1: 15.3274,
    x2: 3.70489,
    y2: 15.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1362_338",
    x1: 5.25558,
    y1: 16.2864,
    x2: 0.180544,
    y2: 17.4498,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1362_338",
    x1: 7.76505,
    y1: 18.3058,
    x2: 5.32195,
    y2: 18.5009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1362_338",
    x1: 7.36647,
    y1: 20.6572,
    x2: 1.61204,
    y2: 22.5995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1362_338",
    x1: 10.4455,
    y1: 21.0055,
    x2: 7.48876,
    y2: 21.2921,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1362_338",
    x1: 10.6117,
    y1: 24.398,
    x2: 4.66578,
    y2: 27.2623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF6A25"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#CD42FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8FB9FC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftPanel);
export default __webpack_public_path__ + "static/media/left_panel.57a4fbf3c06d881a1728abd1bb05eeb4.svg";
export { ForwardRef as ReactComponent };